<mwe-card-with-product-list
  [categories]="categories()"
  [address]="address()"
  [description]="'shared.accountNumber' | translate: { accountNumber: accountNumber() }"
  [noBox]="noBox()"
  [oneRow]="oneRow()"
/>
